import { PlusCircle } from "react-feather";
import DataTable from "../Generic/DataTable";
import React, { useContext, useEffect, useRef, useState } from "react";
import { tenantContext } from "../Main/contexts";
import {
    GetMailboxTemplates,
    GetMembership,
    MailboxMembers,
    UpdateMailboxTemplates,
    UpdateMembership,
} from "./TenantAPI";
import Loading from "../Generic/loading";
import { dataColumn } from "../Generic/DataTable";
import { sortByField, SortEnquiriesParams } from "../Logic/sort";
import { Departments, GetDepartmentResponse, GetDepartments } from "../Logic/department";
import { GetMailboxRoles, MailboxRolesListItemDTO } from "../Roles/TenantAPI";
import { GetMailboxes, MailboxList } from "./TenantAPI";
import { GetUsers, UsersGridListDTO, UsersListDTO } from "../Users/TenantAPI";
import CheckBoxList from "../Generic/CheckboxList";
import { iDataColumn } from "../EmsSetup/TenantAPI";
import { GetConfig, GetConfigResponse } from "../Logic/config";

function Templates() {
    const { selectedTenant, departments, setDepartments } = useContext(tenantContext);
    const [isLoading, setIsLoading] = useState<Boolean>(true);
    const [allUsers, setAllUsers] = useState<Array<UsersGridListDTO>>([]);
    const [config, setConfig] = useState<GetConfigResponse | undefined>(undefined);
    const [sortBy, setSortBy] = useState<SortEnquiriesParams>();
    const [selectedItem, setSelectedItem] = useState("");
    const [mailboxes, setMailboxes] = useState<Array<MailboxList>>([]);
    const [mailboxesFiltered, setmailboxesFiltered] = useState<Array<MailboxList>>([]);
    const [mailboxRoles, setMailboxroles] = useState<Array<MailboxRolesListItemDTO>>([]);
    const [isNewUser, setIsNewUser] = useState<Boolean>(true);
    const [validationErrors, setValidationErrors] = useState<Array<string>>([]);
    const [mailboxTemplates, setMailboxTemplates] = useState<Array<iDataColumn> | undefined>(undefined);
    const [updateTs, setUpdateTs] = useState<number[]>([]);

    useEffect(() => {
        (async () => {
            if (selectedTenant) {
                const mailboxes_results = GetMailboxes(selectedTenant.token);
                const config_results = GetConfig(selectedTenant.token);

                Promise.all([mailboxes_results, config_results]).then(results => {
                    if (results[0].isOk) {
                        setMailboxes(results[0].data?.items!);
                        setmailboxesFiltered(results[0].data?.items!);
                    }
                    if (results[1].isOk) {
                        let result = results[1].data;
                        result?.templates.sort((a, b) => a.name.localeCompare(b.name));
                        result?.skins.sort((a, b) => a.name.localeCompare(b.name));
                        result?.tags.sort((a, b) => a.friendlyName.localeCompare(b.friendlyName));
                        setConfig(result);
                    }

                    setIsLoading(false);
                });
            }
        })();
    }, [selectedTenant]);

    async function getDepartments() {
        if (selectedTenant) {
            if (departments.length == 0) {
                const departments_results = GetDepartments(selectedTenant.token);
                Promise.all([departments_results]).then(results => {
                    if (results[0].isOk) {
                        setDepartments(results[0].data?.items!);
                    }
                    setIsLoading(false);
                });
            }
        }
    }

    let AllColumns: dataColumn<MailboxList>[] = [
        {
            title: <>Mailbox</>,
            toolTip: "name",
            key: "name",
            getData: (data: MailboxList) => {
                return <>{data.name}</>;
            },
            width: "100%",
            canResize: false,
            sort: {
                direction: undefined,
                sortMethod: () => {
                    handleHeaderClick("name");
                },
                displayIcon: false,
            },
            textAlignment: "left",
            minWidth: "60px",
        },
    ];

    const handleHeaderClick = (fieldName: string): any => {
        let sortO = sortBy;
        if (!sortO) {
            sortO = {
                orderBy: fieldName,
                desc: false,
            };
        } else {
            sortO.orderBy = fieldName;
            sortO.desc = sortO.desc ? false : true;
        }
        let updatedGrids = sortByField(mailboxesFiltered, fieldName, sortO.desc);
        setmailboxesFiltered(updatedGrids);
        setSortBy(sortO);
    };

    function OnFilter(filterValue: string) {
        let filtertedList = mailboxes;
        let filtered = filtertedList.filter(x => x.name.toLowerCase().includes(filterValue.toLowerCase()));
        setmailboxesFiltered(filtered);
    }

    async function getMailboxMembershipInfo(id: string) {
        if (selectedTenant) {
            setSelectedItem(id);
            const result = await GetMailboxTemplates(selectedTenant.token, parseInt(id));
            if (result.isOk && result.data) {
                setMailboxTemplates(result.data.items);
                setUpdateTs(result.data.items.flatMap(x => x.id));
                setIsNewUser(false);
            }
        }
    }
    const updateMailboxTemplates = (val: string[]) => {
        const numberArray: number[] = val.map(str => +str);
        setUpdateTs(numberArray);
    };

    const updateTemplatesForMailbox = async () => {
        if (selectedTenant && updateTs) {
            const result = await UpdateMailboxTemplates(selectedTenant.token, parseInt(selectedItem), {
                templates: updateTs,
            });
            if (result.isOk) {
                alert("Templates Updated");
            }
        }
    };
    return (
        <>
            <div className="topSection">
                <div className="sectionHeader"> Mailbox - Templates</div>
                {mailboxTemplates && !isNewUser && (
                    <div>
                        <button
                            className="g-btn-large btn-primary"
                            onClick={updateTemplatesForMailbox}
                        >
                            {" "}
                            Update Templates{" "}
                        </button>
                    </div>
                )}
            </div>
            <div style={{ display: "flex", flexDirection: "row", height: "calc(100% - 44px)" }}>
                <div className="Users-bodyCol1">
                    {isLoading && <Loading></Loading>}
                    {!isLoading && (
                        <>
                            <div className="filterContainer">
                                <div>Filter: </div>
                                <div>
                                    <input
                                        type="text"
                                        style={{ width: "100%" }}
                                        onChange={e => OnFilter(e.currentTarget.value)}
                                        defaultValue={""}
                                    />
                                </div>
                            </div>
                            <DataTable
                                data={mailboxesFiltered}
                                columns={AllColumns}
                                onRowClick={(val: string) => {
                                    getMailboxMembershipInfo(val);
                                }}
                                onRowDblClick={() => {}}
                                selectedItem={selectedItem}
                                uniqueIdentifiyer={x => {
                                    return x.id.toString();
                                }}
                            ></DataTable>
                        </>
                    )}
                </div>
                {mailboxTemplates && (
                    <div className="bodyCol2">
                        <div className="optionsRow">
                            <p style={{ marginBottom: "6px", marginTop: "-0px", fontWeight: "bold", fontSize: "12pt" }}>
                                Templates{" "}
                            </p>
                        </div>

                        <div className="formRow">
                            <CheckBoxList
                                id={"Templates_Id"}
                                label=""
                                options={
                                    config
                                        ? config.templates.map(x => {
                                              return { label: x.name, value: x.id.toString() };
                                          })
                                        : []
                                }
                                value={updateTs ? updateTs.map(num => num.toString()) : []}
                                errorMessage=""
                                onChange={updateMailboxTemplates}
                                height="460px"
                            ></CheckBoxList>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
}
export default Templates;
